import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=87d8533e&scoped=true&"
import script from "./Albums.vue?vue&type=script&lang=js&"
export * from "./Albums.vue?vue&type=script&lang=js&"
import style0 from "./Albums.vue?vue&type=style&index=0&data-page=albums&lang=css&"
import style1 from "./Albums.vue?vue&type=style&index=1&id=87d8533e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d8533e",
  null
  
)

export default component.exports